import { addMonths } from 'date-fns';
import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class GerenciadorArquivoService extends BaseService {
  constructor() {
    super(`${ConfigApi.gerenciadorArquivoURL}`);
  }

  getFilter() {
    return new Filter();
  }

  async insert(body) {
    delete body.id;

    const data = new FormData();
    Object.keys(body).forEach(k => {
      data.append(k, body[k]);
    });

    this.setLoading(true);
    try {
      const response = await this.api.post(this.url, data, {
        onUploadProgress: evt => {
          if (evt.total) {
            const pct = Math.round((evt.loaded * 100) / evt.total);
            // atualize seu estado/UI aqui

            this.setProgress(pct);
            // opcional: velocidade e tempo restante
            // const elapsed = (evt.timeStamp ?? 0) / 1000; // ms -> s (nem sempre útil)
          } else {
            // fallback: progresso indeterminado
            this.setProgress(0);
          }
        },
        timeout: 0,
      });

      return response.data;
    } finally {
      this.setLoading(false);
      this.setProgress(null);
    }
  }

  async update(body) {
    const data = new FormData();
    Object.keys(body).forEach(k => {
      data.append(k, body[k]);
    });

    this.setLoading(true);
    try {
      const response = await this.api.put(`${this.url}/${body.id}`, data, {
        onUploadProgress: evt => {
          if (evt.total) {
            const pct = Math.round((evt.loaded * 100) / evt.total);
            // atualize seu estado/UI aqui

            this.setProgress(pct);
            // opcional: velocidade e tempo restante
            // const elapsed = (evt.timeStamp ?? 0) / 1000; // ms -> s (nem sempre útil)
          } else {
            // fallback: progresso indeterminado
            this.setProgress(0);
          }
        },
        timeout: 0,
      });

      return response.data;
    } finally {
      this.setLoading(false);
      this.setProgress(null);
    }
  }

  async getFile(uri) {
    this.setLoading(true);
    try {
      const response = await this.api.get(`/files/${uri}`, {
        responseType: 'blob',
        onDownloadProgress: evt => {
          if (evt.total) {
            const pct = Math.round((evt.loaded * 100) / evt.total);
            // atualize seu estado/UI aqui
            this.setProgress(pct);
            // opcional: velocidade e tempo restante
            // const elapsed = (evt.timeStamp ?? 0) / 1000; // ms -> s (nem sempre útil)
          } else {
            // fallback: progresso indeterminado
            this.setProgress(0);
          }
        },
      });

      return response.data;
    } finally {
      this.setLoading(false);
      this.setProgress(null);
    }
  }
}

class Filter {
  constructor() {
    this.id = 0;
    this.nomeArquivo = '';
    this.idArquivoCategoria = undefined;
    this.idArquivoSubcategoria = undefined;
    this.dataInicio = addMonths(new Date(), -48);
    this.dataFim = new Date();

    this.limit = 11;
    this.page = 0;
  }
}

export default new GerenciadorArquivoService();
